module.exports = __webpack_public_path__ + "static/media/api.7397e18b.svg";